import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-da378f94")
const _hoisted_1 = {
  key: 0,
  class: "admin-area"
}
const _hoisted_2 = { class: "inner flex-box jc-sb" }
const _hoisted_3 = { class: "controll-area flex-box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ri-add-line ri-xl" }, null, -1)
const _hoisted_5 = { class: "questions" }
const _hoisted_6 = { class: "question-body flex-box ai-c" }
const _hoisted_7 = { class: "controll-btn-area" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ri-delete-bin-line ri-xl" }, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line ri-2x" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "detail" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "head flex-box fw-nw" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "order" }, "回答順"),
  /*#__PURE__*/_createElementVNode("p", { class: "post-time" }, "回答時刻"),
  /*#__PURE__*/_createElementVNode("p", { class: "diff-from-first" }, "1位との差"),
  /*#__PURE__*/_createElementVNode("p", { class: "diff-from-before" }, "1つ上との差")
], -1)
const _hoisted_14 = { class: "wrap-time" }
const _hoisted_15 = { class: "order" }
const _hoisted_16 = { class: "post-time" }
const _hoisted_17 = { class: "diff-from-first" }
const _hoisted_18 = { class: "diff-from-before" }
const _hoisted_19 = {
  key: 2,
  class: "type-pass-area"
}
const _hoisted_20 = { class: "controll-area flex-box jc-c inner" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("確定")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_multiline_field = _resolveComponent("multiline-field")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_card = _resolveComponent("card")!
  const _component_divider = _resolveComponent("divider")!
  const _component_chat_area = _resolveComponent("chat-area")!
  const _component_expired_screen = _resolveComponent("expired-screen")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_hamburger_menu = _resolveComponent("hamburger-menu")!
  const _component_launch_admin_screen = _resolveComponent("launch-admin-screen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loader, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    (!_ctx.showTypePassScreen && !_ctx.showExpiredScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_header_menu, {
            showHeaderMenu: true,
            title: _ctx.roomObj.roomTitle || 'ルームタイトルが取得できませんでした',
            onClickMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openHamburgerMenu = true))
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", {
              class: "question-area",
              style: _normalizeStyle({ width: `${_ctx.leftWidth}%` })
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_multiline_field, {
                  inputVal: _ctx.questionTxt,
                  "onUpdate:inputVal": _cache[1] || (_cache[1] = ($event: any) => (_ctx.questionTxt = $event)),
                  placeholder: "進捗管理したい問題を入力",
                  onKeydown: [
                    _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.addQuestion()), ["ctrl"]), ["enter"])),
                    _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.addQuestion()), ["meta"]), ["enter"]))
                  ]
                }, null, 8, ["inputVal"]),
                _createVNode(_component_custom_button, {
                  type: "round",
                  width: 44,
                  height: 44,
                  centering: true,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addQuestion()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionIdList, (questionId, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: questionId }, [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "flex-box jc-sb",
                          style: {"width":"100%"},
                          ref: `question-${questionId}`
                        }, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.questionObj[questionId].body), 1),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_custom_button, {
                              type: "round",
                              centering: true,
                              width: 44,
                              height: 44,
                              onClick: ($event: any) => (_ctx.deleteQuestion(questionId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ], 512),
                        _createElementVNode("div", {
                          ref: `question-${questionId}`,
                          class: _normalizeClass(["flex-box jc-sb", { 'is-open': _ctx.showDetails[index] }]),
                          style: {"width":"100%","margin-top":"10px"}
                        }, [
                          _createVNode(_component_progress_bar, {
                            completeVal: 
                    _ctx.calcPercentage(
                      _ctx.roomObj.studentNum,
                      _ctx.questionObj[questionId].completedUsers.length
                    )
                  ,
                            showPercentage: true,
                            style: {"width":"calc(100% - 50px)"}
                          }, null, 8, ["completeVal"]),
                          _createElementVNode("button", {
                            class: "toggle-detail flex-box jc-c ai-c",
                            type: "button",
                            onClick: ($event: any) => (_ctx.toggleShowDetails(index))
                          }, _hoisted_11, 8, _hoisted_9),
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("ol", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionObj[questionId]
                        .completedUsers, (userId, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: `time-${String(index)}`,
                                  class: "flex-box"
                                }, [
                                  _createElementVNode("p", _hoisted_15, _toDisplayString(Number(index) + 1), 1),
                                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.convertDateToString(
                            _ctx.getPostTime(
                              _ctx.questionObj[questionId].completedUserInfo[userId]
                                .timeStamp
                            ),
                            'MM月DD日 hh時mm分ss秒'
                          )), 1),
                                  _createElementVNode("p", _hoisted_17, _toDisplayString(index === 0
                            ? '-'
                            : _ctx.calcDiffTarget(questionId, 0, Number(index))), 1),
                                  _createElementVNode("p", _hoisted_18, _toDisplayString(index === 0
                            ? '-'
                            : _ctx.calcDiffTarget(
                                questionId,
                                Number(index) - 1,
                                Number(index)
                              )), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 2)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ], 4),
            _createVNode(_component_divider, { onChangePosition: _ctx.changeWidth }, null, 8, ["onChangePosition"]),
            _createVNode(_component_chat_area, {
              roomId: _ctx.roomId,
              style: _normalizeStyle({ width: `${99 - _ctx.leftWidth}%` })
            }, null, 8, ["roomId", "style"])
          ])
        ]))
      : (_ctx.showExpiredScreen)
        ? (_openBlock(), _createBlock(_component_expired_screen, { key: 1 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_header_menu, {
              showHeaderMenu: false,
              title: _ctx.roomObj.roomTitle || 'ルームタイトルが取得できませんでした'
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_text_field, {
                inputVal: _ctx.inputPassword,
                "onUpdate:inputVal": _cache[5] || (_cache[5] = ($event: any) => (_ctx.inputPassword = $event)),
                value: _ctx.inputPassword,
                type: "password",
                placeholder: "管理画面のルームパスワードを入力",
                onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.checkPassword(_ctx.inputPassword)), ["enter"]))
              }, null, 8, ["inputVal", "value"]),
              _createVNode(_component_custom_button, {
                type: "round",
                style: {"margin-left":"10px"},
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkPassword(_ctx.inputPassword)))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ])
          ])),
    _createVNode(_component_hamburger_menu, {
      open: _ctx.openHamburgerMenu,
      roomObj: _ctx.roomObj,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openHamburgerMenu = false))
    }, null, 8, ["open", "roomObj"]),
    _createVNode(_component_launch_admin_screen, {
      open: _ctx.showLaunchScreen,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showLaunchScreen = false))
    }, null, 8, ["open"])
  ], 64))
}